import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../../../loader/Loader";
import AxiosController from "../../../../authentication/AxiosController";
import StatisticsSearchComponent from "../search components/StatisticsSearchComponent";
import { Button, Table } from "react-bootstrap";

const SellersOverview = () => {
  const { slug, lang } = useParams();
  const { t } = useTranslation("global");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [search, setSearch] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sellerId, setProductId] = useState("");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  const getSellersOverview = () => {
    setLoading(true);
    AxiosController.get(`api/${slug}/${lang}/reports/sellers-overview`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        start_date: startDate,
        end_date: endDate,
        seller_id: sellerId,
      },
    })
      .then((res) => {
        setLoading(false);
        setAllData(res?.data?.sellers || []);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    setProductId(urlParams.get("seller_id") || "");
    setStartDate(urlParams.get("start_date") || "");
    setEndDate(urlParams.get("end_date") || "");
  }, [urlParams]);

  useEffect(() => {
    getSellersOverview();
  }, [startDate, endDate, sellerId]);

  return (
    <div className="flex-grow-1 stats-component py-3">
      <Button
        className="fs-5 w-25 mb-4 align-self-start"
        style={{
          backgroundColor: "rgb(89, 198, 201)",
          border: "none",
          borderRadius: "7px",
        }}
        onClick={() => setSearch(!search)}
      >
        {t("panel.search")}
      </Button>
      {search && <StatisticsSearchComponent type={"seller_overview"} />}

      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <Loader active={loading} />

        <div className="row" style={{ height: "1200px" }}>
          <div
            className="col-12"
            style={{ position: "relative", overflowX: "auto", height: "100%" }}
          >
            <Table>
              <thead>
                <tr className="text-center">
                  <th>{t("panel.seller")}</th>
                  <th>{t("panel.quantity")}</th>
                  <th>{t("panel.seller_commission")}</th>
                  <th>{t("panel.marketer_commission")}</th>
                  <th>{t("panel.sys_commission")}</th>

                </tr>
              </thead>
              <tbody>
                {allData.length > 0 &&
                  allData.map((item) => (

                    <tr className="text-center" key={item?.seller_id}>
                      <td>
                        {item.seller_id} #
                        <br />
                        {item.seller_first_name} {item.seller_last_name}
                      </td>
                      <td>
                        {Number(item.quantity).toLocaleString()}
                        
                      </td>
                      <td>
                        {Number(item.seller_commission).toLocaleString()}                     
                      </td>
                      <td>
                        {Number(item.marketer_commission).toLocaleString()}
                      </td>
                      <td>
                        {Number(item.sys_commission).toLocaleString()}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellersOverview;
